import 'css-chunksrc/client/pages/zonesPage/projectsPage/zone/styles.scss';export default {
  "projectsPage": "_projectsPage_4bb6y_1",
  "content": "_content_4bb6y_10",
  "main": "_main_4bb6y_17",
  "header": "_header_4bb6y_25",
  "row": "_row_4bb6y_32",
  "contextualMenuIcon": "_contextualMenuIcon_4bb6y_36",
  "wbsConfigurationIcon": "_wbsConfigurationIcon_4bb6y_44",
  "addZoneButton": "_addZoneButton_4bb6y_54",
  "wrapper": "_wrapper_4bb6y_58",
  "zoneInfo": "_zoneInfo_4bb6y_76",
  "iconBox": "_iconBox_4bb6y_89",
  "avatar": "_avatar_4bb6y_97",
  "scrollingText": "_scrollingText_4bb6y_105",
  "name": "_name_4bb6y_109",
  "list": "_list_4bb6y_115",
  "item": "_item_4bb6y_122",
  "zones": "_zones_4bb6y_130",
  "exportButton": "_exportButton_4bb6y_137",
  "removeIcon": "_removeIcon_4bb6y_144"
};